module.exports = "\n\n<div ll-date-range-select ng-model=\"state.range\" range-only-monthly=\"true\"></div>";